import quiz from 'assets/subscription/quiz.svg';
import SubscribeButtons from 'components/altus-plus/subscribe-buttons';
import SubscriptionBackHeader from 'components/altus-plus/subscription-back-header';
import Flex from 'components/flex/flex';
import { useStatusBarHeight } from 'hooks/use-status-bar-height';
import { useNavigate } from 'react-router-dom';
import { SegmentEventType, track } from 'segment';
import styles from './subscription.module.scss';

export default function Subscription3() {
  const statusBarHeight = useStatusBarHeight();
  const navigate = useNavigate();

  return (
    <div className={styles.background} style={{ paddingTop: statusBarHeight }}>
      <Flex direction="column" align="center" width="100%" height="100%" pad="20px" justify="space-between">
        <SubscriptionBackHeader
          onBack={() => {
            navigate(-2);
            track(SegmentEventType.EXIT_PAYMENT_FLOW);
          }}
        />

        <img className={styles.quizArguments} src={quiz} alt="Quiz" />

        <div className={styles.subscriptionBottomText}>
          Vos enfants réalisent des quiz <b>éducatifs</b> pour débloquer plus de <b>temps d’écran</b>
        </div>

        <SubscribeButtons
          backAmount={-2}
          trackingEvent={SegmentEventType.PAYMENT_ARGUMENTS_3}
          trackingProperties={{}}
          nextHref="/subscribe/arguments/4"
          nextText="SUIVANT"
        />
      </Flex>
    </div>
  );
}
